module.exports = __webpack_public_path__ + "static/media/right-arrow-white.72160d80.svg";